import { Injectable, NgZone } from "@angular/core";
import {
    NavController,
    ModalController,
} from "@ionic/angular";
import { AppStoreDispatcher } from "../state/app.state.dispatcher";
import { Functions } from '@angular/fire/functions';

import { Firestore } from "@angular/fire/firestore";
import { SopoLoadingService } from "src/app/shared/services/sopo-loading/sopo-loading.service";
import { ClubStateDispatcher } from "../state/club/club.dispatcher";
import { ApiService } from "../backend/api.service";
import { DEFAULT_DISMISS_AFTER_TIME, SopoPopupService } from "src/app/sopo-popup/service/sopo-popup.service";
import { PurchaseConfirmationComponent } from "src/app/shop/component/purchase-confirmation/purchase-confirmation.component";

@Injectable({
    providedIn: "root",
})
export class ShopService {

    constructor(
        public loadingCtrl: SopoLoadingService,
        public cloudFNs: Functions,
        public appStateDispatch: AppStoreDispatcher,
        public firestore: Firestore,
        public navCtrl: NavController,
        public modalCtrl: ModalController,
        public clubStateDispatch: ClubStateDispatcher,
        public apiService: ApiService,
        private zone: NgZone,
        private sopoPopupService: SopoPopupService,
    ) { }

    public async purchaseFailedAlert() {
        await this.sopoPopupService.showAlert('app', { message: `Purchase failed. Try again later.`, dismissAfter: DEFAULT_DISMISS_AFTER_TIME });
    }

    public purchaseConfirmation() {
        this.zone.run(async () => {
            const doNotShowPurchaseConfirmation = localStorage.getItem('doNotShowPurchaseConfirmation');
            if (!doNotShowPurchaseConfirmation || doNotShowPurchaseConfirmation === 'false') {
                this.sopoPopupService.openDialog('app', PurchaseConfirmationComponent, {
                    closeButton: true,
                })
            }
        })
    }
}
